import type { Alignment } from '@floating-ui/react-dom';
import type { Column, RowData } from '@tanstack/react-table';
import type React from 'react';
import type { kkTableFeatures, TableInstance } from '../tableFeatures';

export type ColumnSortDirection = false | 'asc' | 'desc';

export interface ColumnFilterAndSortPopoverProps<TData extends RowData> {
  label: React.ReactNode;
  alignment?: Alignment;
  onChange?: (value: string | string[]) => void;
  column?: Column<typeof kkTableFeatures, TData, unknown>;
  filterValue: unknown;
  data: TData[];
  table: TableInstance<TData>;
  isSortable?: boolean;
  sortDirection: ColumnSortDirection;
}

export function getColumnFilterState<TData extends RowData>(
  props: ColumnFilterAndSortPopoverProps<TData>,
) {
  const selectedFilterCount = Array.isArray(props.filterValue)
    ? props.filterValue.length
    : 0;
  const filterCountBadge =
    selectedFilterCount > 99 ? '99+' : selectedFilterCount.toString();

  return { values: props.filterValue, selectedFilterCount, filterCountBadge };
}

type SelectStyleFilterColumnDef = {
  filterFn?: unknown;
  meta?: { filterVariant?: unknown };
};

export function supportsSelectStyleFiltering(
  columnDef?: SelectStyleFilterColumnDef,
) {
  return (
    columnDef?.filterFn === 'arrHas' ||
    columnDef?.filterFn === 'arrIncludes' ||
    columnDef?.filterFn === 'arrIncludesAll' ||
    columnDef?.meta?.filterVariant === 'select'
  );
}
